import { TaaConfigs, ClientType } from '@amzn/atoz-dashboard-taa-components';
import { getCurrentStage, STAGE } from 'src/constants/StageConfig';
import { DEFAULT_LOCALE } from 'src/constants';
import { hasFeature } from 'src/features';
import { PopstarFeature } from 'src/features/featureTypes';

export const reverseProxyApiGatewayUrl: { [key in STAGE]: string } = {
  test: 'https://atoz.integ.amazon.com',
  alpha: 'https://atoz.integ.amazon.com',
  beta: 'https://atoz.integ.amazon.com',
  gamma: 'https://atoz.integ.amazon.com',
  prod: 'https://atoz-apps.amazon.work',
};

export const getTAAComponentConfig = (employeeInfo: EmployeeInfo): TaaConfigs => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const popstarFeatures = window['AtoZContext']?.employee?.enabledFeatures;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const languageLocale = window['AtoZContext']?.employee?.localePreferences?.languageCode || DEFAULT_LOCALE;
  const isReverseProxyEnabled: boolean = popstarFeatures.includes('proxy_migration_atoz_timehub_assistant');
  return {
    clientName: 'AtoZ-TimeHub-Assistant',
    host: isReverseProxyEnabled ? reverseProxyApiGatewayUrl[getCurrentStage()] : undefined,
    associateInfo: {
      employeeId: employeeInfo.employeeId,
      locale: languageLocale,
      siteId: employeeInfo.buildingCode,
      timeZone: employeeInfo.timeZoneId,
    },
    isBalances1PMigrationEnabled: hasFeature(popstarFeatures, PopstarFeature.BALANCES_1P_MIGRATION),
    clientType: ClientType.WEB,
  };
};
